/**
 * @todo Удалить файл с экспериментом
 * @description Данный функционал появился в задаче CD-129223, будет удалён в задаче CD-129224
 * Удалить, если эксперимент будет не удачным
 */

import { IAgentSchema, IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';
import { IMicrofrontendsAPI } from 'shared/types/applicationContext';

import { trackPhonesLimitShown } from './tracking/trackPhonesLimitShown';

/**
 * @deprecated
 * @todo Удалить комментарий с экспериментом
 * @description Данный функционал появился в задаче CD-129223, будет удалён в задаче CD-129224
 * Удалить если эксперимент будет удачным
 */
export function showPhonesLimitAuth(
  offer: IOfferSchema,
  agent: IAgentSchema | null,
  microfrontendsAPI?: IMicrofrontendsAPI,
) {
  trackPhonesLimitShown(offer, agent);

  void microfrontendsAPI?.header.openAuthModal({
    autoRefresh: true,
    alert: null,
    useDefaultView: false,
    viewData: { headingType: 'phoneAuthPermission' },
    source: null,
  });
}
